export default __webpack_public_path__ + "static/media/correspondent6.916fe034.png";